import React from 'react';
import { toast } from 'sonner';
import { DONATION_TIERS } from '../../mock';
import { postEnquiry } from '../../api';
import { logError } from '../../lib/logger';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../ui/dialog';

const TierButton = ({ tier, onSelect }) => (
  <button
    onClick={() => onSelect(tier)}
    className="group flex w-full items-center justify-between border border-white/15 px-5 py-4 text-left transition-colors duration-300 hover:border-gold"
  >
    <span>
      <span className="block text-xs tracking-[0.2em] text-white transition-colors duration-300 group-hover:text-gold">
        {tier.name}
      </span>
      <span className="mt-1 block text-[10px] tracking-[0.08em] text-neutral-500">{tier.note}</span>
    </span>
    <span className="text-xs tracking-[0.1em] text-gold">{tier.amount}</span>
  </button>
);

export const DonateDialog = ({ cause, onClose }) => {
  const donate = async (tier) => {
    try {
      await postEnquiry('donation', {
        Cause: cause.title,
        Tier: tier.name,
        Amount: tier.amount,
      });
    } catch (err) {
      logError('Donation pledge failed:', err);
      toast.error('Could not record your donation', {
        description: 'Please check your connection and try again in a moment.',
      });
      return;
    }
    onClose();
    toast.success('Thank you for your generosity', {
      description: `${tier.name} · ${cause.title} — every contribution creates impact.`,
    });
  };

  return (
    <Dialog open={!!cause} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="border-white/10 bg-ink text-neutral-200 sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="font-serif text-2xl font-light tracking-[0.05em] text-white">
            DONATE TO THE CAUSE
          </DialogTitle>
          <DialogDescription className="text-[10px] uppercase tracking-[0.3em] text-gold">{cause?.title}</DialogDescription>
        </DialogHeader>
        <div className="space-y-3 pt-2">
          {DONATION_TIERS.map((tier) => (
            <TierButton key={tier.id} tier={tier} onSelect={donate} />
          ))}
        </div>
        <p className="pt-1 text-[10px] leading-relaxed tracking-[0.05em] text-neutral-600">
          Preview build — donations are stored locally and will connect to a payment partner in the full version.
        </p>
      </DialogContent>
    </Dialog>
  );
};
